import useSWR from 'swr';
import { useState, useEffect } from 'react';
import { axios } from '@service/axiosService';
import actions from '@flux/action';
import { useDispatch, useSelector } from 'react-redux';
import { getSessionStorage } from '@utils/windowUtil';

export const useMultiSection = (link = null) => {
  const currentProjectId = getSessionStorage('currentId');
  const [moduleValue, setModuleValue] = useState(link);
  const urlGet = `/api/v1/project/multipleModule/${currentProjectId}/${moduleValue}`;
  const urlPost = `/api/v1/project/multipleModule/${currentProjectId}/${moduleValue}`;

  useEffect(() => {
    if (link) {
      setModuleValue(link);
    } else if (moduleValue) {
      setModuleValue(null);
    }
  }, [link]);

  const fetcher = () => axios.get(urlGet);

  const { data, error, mutate, isLoading } = useSWR(moduleValue, fetcher, {
    dedupingInterval: 30000,
  });

  const saveMultiSection = async (newData) => {
    await mutate(
      axios.post(urlPost, newData).then(() => newData),
      {
        rollbackOnError: true,
        populateCache: false,
      },
    );
  };

  return {
    moduleId: data?.moduleId,
    sectionListData: data?.sectionList?.map((x) => {
      x.identifier = x.id;
      return x;
    }),
    displaySectionListData: data?.displaySectionList,
    saveMultiSection,
    error,
    isLoading,
  };
};
